import { useParams } from 'react-router-dom'
import ComplianceShell from 'features/compliance/ComplianceShell'
import RemedialsWorkspace from 'features/actions/workspace/RemedialsWorkspace'

const RemedialsSection = ({ bpId: bpIdProp, embedded = false, onTabChange, chromeless = false } = {}) => {
  const params = useParams()
  const bpId = bpIdProp ?? params.bpId
  return (
    <ComplianceShell activeTab='remedials' bpId={bpId} embedded={embedded} onTabChange={onTabChange} chromeless={chromeless}>
      <RemedialsWorkspace scope={{ kind: 'building', id: bpId }} compact />
    </ComplianceShell>
  )
}

export default RemedialsSection
